import React, { useEffect, useState, useContext } from "react";
import { Grid, Typography, Button, TextField, Autocomplete, CircularProgress, } from "@mui/material";
import { useTranslation } from "react-i18next";
import AlertMessage from "./modules/AlertMessage";
import { baseUrl } from "./modules/general";
import axios from "axios";


export default function GroupPriceChanging() {
  const { t, i18n } = useTranslation();
  const [alert, setAlert] = useState({ alertCheck: false, message: "", severity: "" });
  const [brandData, setBrandData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [group, setGroup] = useState("");
  const [brand, setBrand] = useState("");
  const [groupId, setGroupId] = useState("");
  const [brandId, setBrandId] = useState("");
  const [select, setSelect] = useState("");
  const [selectID, setSelectID] = useState('');
  const [darsad, setDarsad] = useState("");
  const [loading, setLoading] = useState(false);
  const [proDis, setProDis] = useState(false);

  useEffect(() => {
    const props = ["G", "B"];
    props.forEach(prop => {
      getProductData(prop);
    });
  }, []);

  const getProductData = (prp) => {
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/get',
      method: "GET",
      params: {
        prop: prp
      },
    }))
      .then((res) => {
        switch (prp) {
          case ("B"):
            setBrandData(res.data.data)
            break;
          case ("G"):
            setGroupData(res.data.data)
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500 ?
          setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
          setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
      })
  }

  const options = [
    { label: i18n.language === "fa" ? "کاهش" : "Decrease", id: 0 },
    { label: i18n.language === "fa" ? 'افزایش' : "Increase", id: 1 },
  ];

  const brandSelect = brandData === null ? [] : brandData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const groupSelect = groupData === null ? [] : groupData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const onchangeGroup = (event, newSelection) => {
    setGroup(newSelection);
    setGroupId(newSelection ? newSelection.id : '')
    setBrand("");
    setBrandId("")
    setSelect("");
    setSelectID("");
    setDarsad("")
  }

  const onchangeBrand = (event, newSelection) => {
    setBrand(newSelection);
    setBrandId(newSelection ? newSelection.id : '')
  }

  const onchangeSelection = (event, newSelection) => {
    setSelect(newSelection);
    setSelectID(newSelection.id);
  }

  const stringValue = (value) => {
    var output = "";
    value = value.toString();
    value = value.split(",");
    for (var i = 0; i < value.length; i++) {
      output += value[i].toString();
    }
    output = output.replace("/", ".");
    return output;
  }

  const onlyFloatnaumber = (value) => {
    value = value.trim();
    value = stringValue(value);
    var regex = new RegExp("^[0-9]*[.]*[0-9]*$");
    if (regex.test(value)) {
      if (value[0] !== '0') {
        return value;
      }
      else {
        if (value.length === 1) {
          return value;
        }
        else {
          if (value.length === 2) {
            if (value[0] === '0' && value[1] === '.') {
              return value;
            }
            else {
              if (value[0] === '0' && value[1] !== '.') {
                return value[1];
              }
            }
          }
          else {
            if (value.length > 2) {
              if (value.substr(2).includes('.')) {
                return value[0] + value[1];
              }
              else {
                return value;
              }
            }
          }
        }
      }
    }
    else {
      return '';
    }
  }

  const replaceNumber = (value, la) => {
    value = value ? value.toString() : '';
    if (la === "fa") {
      value = value.replace(".", "/");
    }
    return value;
  }

  const separator = (value) => {
    value = value ? value.toString() : '';
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    }
    else {
      value = camaInsert(value);
    }
    return value;
  }

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(value.length - value.length % 3, value.length))
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        }
        else {
          outputString = outputString + output[j];
        }
      }
    }
    else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3))
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        }
        else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const changePercentage = () => {
    setLoading(true);
    setProDis(true);
    let data = {
      G: groupId,
      I: selectID,
      P: darsad
    };
    if (brandId) {
      data.B = brandId;
    }
    const AuthStr = 'bearer ' + (localStorage.getItem('TACC'));
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/addPrice',
      method: "POST",
      headers: {
        'Authorization': AuthStr,
      },
      data: data
    }))
      .then((res) => {
        setProDis(false)
        setLoading(false)
        setAlert({ alertCheck: true, message: "درصد اعمال شد", severity: "success" })
        setBrand("");
        setBrandId("");
        setGroup("");
        setGroupId("");
        setSelect("");
        setSelectID("");
        setDarsad("");
      })
      .catch(
        (error) => {
          const { status } = error.response;
          switch (status) {
            case (500):
              setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" })
              break;
            case (400):
              setAlert({ alertCheck: true, message: "درخواست نامعتبر است", severity: "error" })
              break;
            default:
              setAlert({ alertCheck: true, message: t("alert_defualt"), severity: "error" })
          }
          setProDis(false)
          setLoading(false)
        })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    return setAlert({ alertCheck: false, message: "", severity: alert.severity })
  };


  return (
    <>
      <Grid sx={{
        display: 'flex', width: "100%", height: "100%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        direction: i18n.language === "fa" ? "rtl" : 'ltr'
      }}>
        <Grid sx={{ width: { xs: "70%", sm: "60%", md: "55%", lg: "40%", xl: "30%" }, display: "flex", flexDirection: "column", flexWrap: "wrap", alignItems: "center" }}>
          <Autocomplete
            value={group}
            onChange={onchangeGroup}
            options={groupSelect}
            getOptionLabel={(option) => option ? option.value || '' : ''}
            renderOption={(props, option) => (
              <Typography component={"li"} {...props}>
                {option.value}
              </Typography>
            )}
            size="medium"
            sx={{
              width: "100%", "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
              , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
              , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }, marginTop: "3em"
            }}
            renderInput={(params) =>
              <TextField
                className="textField"
                label="انتخاب دسته"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
              />}
            isOptionEqualToValue={(option, value) => {
              if (!value) return false;
              return option.id === value.id;
            }}
          />
          <Autocomplete
            value={brand}
            onChange={onchangeBrand}
            options={brandSelect}
            getOptionLabel={(option) => option ? option.value || '' : ''}
            renderOption={(props, option) => (
              <Typography component={"li"} {...props}>
                {option.value}
              </Typography>
            )}
            size="medium"
            sx={{
              width: "100%", "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
              , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
              , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }, marginTop: "2em"
            }}
            renderInput={(params) =>
              <TextField
                className="textField"
                label="انتخاب برند"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
              />}
            isOptionEqualToValue={(option, value) => {
              if (!value) return false;
              return option.id === value.id;
            }}
          />
          <Autocomplete
            value={select}
            onChange={onchangeSelection}
            options={options}
            getOptionLabel={(option) => option ? option.label || '' : ''}
            renderOption={(props, option) => (
              <Typography component={"li"} {...props}>
                {option.label}
              </Typography>
            )}
            size="medium"
            sx={{
              width: '100%', "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
              , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
              , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }, marginTop: "2em"
            }}
            renderInput={(params) =>
              <TextField
                className="textField"
                label="کاهش یا افزایش"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
              />}
            isOptionEqualToValue={(option, value) => {
              if (!value) return false;
              return option.id === value.id;
            }}
          />
          <TextField
            placeholder="درصد کاهش یا افزایش(فقط عدد)"
            className="textField"
            variant='outlined'
            fullWidth
            value={replaceNumber(separator(darsad), i18n.language)}
            onChange={(e) => setDarsad(onlyFloatnaumber(e.target.value))}
            sx={{
              width: '100%', background: "#FFFFFF",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: "2em"
            }}
          />
          <Button
            onClick={changePercentage}
            disabled={proDis} sx={{
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "0px 2px", marginTop: "3em",
              "&:hover": { backgroundColor: "#FF3951" }, backgroundColor: "#FF3951", width: { xs: "100px", md: "200px" }, height: { xs: "35px", md: "50px" }, borderRadius: "25px"
            }} >
            <Typography component={"p"} sx={{ color: "white", fontSize: "17px", fontWeight: "bold" }}>
              {proDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : 'تغییر درصد'}
            </Typography>
          </Button>
        </Grid>
        <AlertMessage open={alert.alertCheck} message={alert.message} duration={3000} close={handleClose} severity={alert.severity} />
      </Grid>
    </>
  )
}